export function getMinMaxPrice(
	prices: number[][],
): [{ price: number }, { price: number }] | [] {
	if (!prices || prices.length === 0) {
		return [];
	}

	return prices.reduce(
		(
			acc: [{ price: number }, { price: number }],
			el: number[],
		): [{ price: number }, { price: number }] => {
			const currentPrice = el[1];

			return [
				{ price: Math.min(acc[0].price, currentPrice) },
				{ price: Math.max(acc[1].price, currentPrice) },
			];
		},
		[{ price: Number.POSITIVE_INFINITY }, { price: Number.NEGATIVE_INFINITY }],
	);
}
